import React from 'react';
import SectionBreak from 'web-ui-kit/ProductDetails/components/SectionBreak';
import Swimlane from 'web-ui-kit/ProductDetails/components/Swimlane';

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function AdditionalOptions(_ref) {
  var _ref$dispatch = _ref.dispatch,
      dispatch = _ref$dispatch === void 0 ? function () {} : _ref$dispatch,
      _ref$mqTwoColumnUp = _ref.mqTwoColumnUp,
      mqTwoColumnUp = _ref$mqTwoColumnUp === void 0 ? '' : _ref$mqTwoColumnUp,
      _ref$productDetailsSt = _ref.productDetailsState,
      productDetailsState = _ref$productDetailsSt === void 0 ? {} : _ref$productDetailsSt,
      _ref$scrollToTop = _ref.scrollToTop,
      scrollToTop = _ref$scrollToTop === void 0 ? function () {} : _ref$scrollToTop;
  var product = productDetailsState.product,
      swapStatus = productDetailsState.swapStatus,
      variants = productDetailsState.variants,
      variantsState = productDetailsState.variantsState,
      variantsLoading = productDetailsState.variantsLoading,
      _productDetailsState$ = productDetailsState.useVariantsForAll,
      useVariantsForAll = _productDetailsState$ === void 0 ? false : _productDetailsState$; // Determine whether to show additional options based
  // on the type of the variant data

  var showAddlOptionsVariants = useVariantsForAll ? !variantsLoading && !!variants && !!variantsState && variantsState.options.length === 0 && Object.keys(variantsState.products || {}) > 0 : !variantsLoading && !!variants && !!variantsState && variants.colorVariants.length === 0 && variants.variants.length > 1; // We only show additional option variants where there is NOT
  // color variants. This is because the color variants UI is
  // more detailed then this more general product card based UI.

  var showAddlOptions = !!product && showAddlOptionsVariants; // Early exit if there is nothing to render.

  if (!showAddlOptions) {
    return null;
  } // The products are a key, value list of variants in the form
  // variantKey: [products list]
  // So we need to merge all product list and reduce into a flat list
  // then filter out the selected product id


  var variantProducts = useVariantsForAll ? Object.values(variantsState.products || {}).reduce(function (acc, productsList) {
    return [].concat(_toConsumableArray(acc), _toConsumableArray(productsList));
  }, []).filter(function (variant) {
    return variant.id !== product.id;
  }) : variants.variants.filter(function (variant) {
    return variant.id !== product.id;
  });
  return (
    /*#__PURE__*/
    React.createElement(React.Fragment, null,
    /*#__PURE__*/
    React.createElement(Swimlane, {
      heading: 'Additional options',
      id: "addlOptions",
      dispatch: dispatch,
      parentProduct: product,
      products: variantProducts,
      scrollToTop: scrollToTop,
      swapStatus: swapStatus
    }),
    /*#__PURE__*/
    React.createElement(SectionBreak, {
      mqHide: mqTwoColumnUp
    }))
  );
}

export default AdditionalOptions;